import { z } from "zod";
import { RoleKindSchema } from "./common";

export const PerDiemBasisSchema = z.enum([
  "per_person_per_day",
  "per_person_per_event",
]);

export const PerDiemPolicySchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  amountPerDay: z.number().int().min(0),
  amountPerEvent: z.number().int().min(0).nullable(),
  basis: PerDiemBasisSchema,
  appliesToRoleKinds: z.array(RoleKindSchema).nullable(),
  status: z.enum(["active", "inactive"]),
  effectiveFrom: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type PerDiemPolicyDTO = z.infer<typeof PerDiemPolicySchema>;

export const CreatePerDiemPolicySchema = z.object({
  code: z.string().min(1, "ຕ້ອງປ້ອນລະຫັດ"),
  name: z.string().min(1, "ຕ້ອງປ້ອນຊື່"),
  amountPerDay: z.number().int().min(1, "ຈຳນວນຕ້ອງ ≥ 1"),
  amountPerEvent: z.number().int().min(0).nullable().optional(),
  basis: PerDiemBasisSchema.default("per_person_per_day"),
  appliesToRoleKinds: z.array(RoleKindSchema).nullable().optional(),
  status: z.enum(["active", "inactive"]).default("active"),
  effectiveFrom: z.string().nullable().optional(),
});
export type CreatePerDiemPolicyDTO = z.infer<typeof CreatePerDiemPolicySchema>;

export const UpdatePerDiemPolicySchema = CreatePerDiemPolicySchema.partial();
export type UpdatePerDiemPolicyDTO = z.infer<typeof UpdatePerDiemPolicySchema>;
